'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const ReactDOM = require('react-dom');
const renderSubtreeIntoContainer = ReactDOM.unstable_renderSubtreeIntoContainer;
const root = require('bunsen/helpers/windowCheck');

const ContextComponent = require('../../global/components/ContextComponent');
const stickyAlertPortal = React.createFactory(require('./StickyAlertPortal'));

class StickyAlert extends ContextComponent {

    componentDidMount() {
        const container = root.document.querySelector(this.props.nodeSelector);
        this.portal = document.createElement('div');
        this.portal.className = 'stickyAlertPortal';
        container.appendChild(this.portal);

        // creating `portal` where StickyAlert children will be placed when `isOpen` is `true`
        this._renderPortal(this.props);
    }

    componentWillReceiveProps(newProps) {
        this._renderPortal(newProps);
        this.portal.classList.toggle('isOpen', newProps.isOpen);
    }

    componentWillUnmount() {
        ReactDOM.unmountComponentAtNode(this.portal);

        try {
            document.body.removeChild(this.portal);
        } catch (err) {
            // Nothing to catch
        }
    }

    _renderPortal(props) {
        this.portalComponent = renderSubtreeIntoContainer(this, stickyAlertPortal(props), this.portal);
    }

    render() {
        return React.DOM.noscript();
    }

}

StickyAlert.propTypes = {
    isOpen: PropTypes.bool,
    nodeSelector: PropTypes.string.isRequired
};

module.exports = StickyAlert;



// WEBPACK FOOTER //
// ./assets/js/components/StickyAlert/StickyAlert.jsx